const columns = [
    { accessorKey: 'name', header: 'Name', meta: { sortBy: 'Name' }, cell: ({ getValue }) => getValue() || '—' },
];

export default columns;
